module.exports = __webpack_public_path__ + "static/media/p2_img2.fa16a863.png";